import {
    addToCustomAlbum,
    addToVigboAlbum,
    back,
    changeDesignBreadcrumbs,
    changeDesignToolbar,
    clear,
    clone,
    copy,
    copyEmailAddress,
    create,
    createAlbum,
    createAndPublishAlbum,
    createBoardClick,
    createBoardShow,
    createFamilyFolder,
    download,
    downloadMobileItem,
    forward,
    makeFamilyFolder,
    makeFamilyFolderCommon,
    more,
    moreAction,
    mount,
    move,
    publish,
    remove,
    rename,
    restore,
    restoreAll,
    selectAll,
    sendComplain,
    setupVigboGallery,
    share,
    shareLink,
    showInParentFolder,
    showPublicInfo,
    sort,
    toggleFavorites,
    unPublish,
    view,
    viewHistory,
    watchVigboGallery,
    writeEmailViaNewTab,
} from './toolbarActions/index';

export const toolbarActions = {
    create,
    writeEmailViaNewTab,
    view,
    sort,
    rename,
    toggleFavorites,
    copy,
    download,
    viewHistory,
    move,
    remove,
    selectAll,
    share,
    publish,
    unPublish,
    restore,
    restoreAll,
    clear,
    forward,
    mount,
    clone,
    shareLink,
    downloadMobileItem,
    showInParentFolder,
    addToCustomAlbum,
    createAndPublishAlbum,
    back,
    createAlbum,
    more,
    // tempexp_17340-start
    moreAction,
    changeDesignToolbar,
    changeDesignBreadcrumbs,
    // tempexp_17340-end
    sendComplain,
    // tempexp_18622-next-line
    showPublicInfo,
    createFamilyFolder,
    makeFamilyFolder,
    makeFamilyFolderCommon,
    copyEmailAddress,
    addToVigboAlbum,
    setupVigboGallery,
    watchVigboGallery,
    createBoardClick,
    createBoardShow,
};
